import React from 'react'
import { Box, Flex, HStack, IconButton, List, ListItem, Text, useColorModeValue, useDisclosure } from '@chakra-ui/react'
import { 
  HamburgerIcon,
  InfoIcon,
  ViewIcon,
  StarIcon,
  ChatIcon,
} from '@chakra-ui/icons'
import { HiHome } from 'react-icons/hi'
import LanguageSelector from '../LanguageSelector'
import BarStrip from '../BarStrip'
import { softwareLanguages } from '../constants/data'
import { color } from '../constants/color'
import calibriteLogo from '../assets/Calibrite-colour-circle_greybg.svg'

const listItems = [
  {
    text: 'Home',
    icon: HiHome,
    disabled: false,
    id: 'home'
  },
  {
    text: 'Account',
    icon: InfoIcon,
    disabled: false,
    id: 'account'
  },
  {
    text: 'Products',
    icon: ViewIcon,
    disabled: false,
    id: 'products'
  },
  {
    text: 'My Library',
    icon: StarIcon,
    disabled: false,
    id: 'library'
  },
  {
    text: 'Community soon',
    icon: ChatIcon,
    disabled: true,
    id: 'community'
  },
]

export default function NavSidebar({ children, onNavigate, activeItem, profileMenu }) {
  const { getButtonProps, isOpen } = useDisclosure({
    defaultIsOpen: true,
  })
  const buttonProps = getButtonProps()

  const handleItemClick = (item) => {
    if (!item.disabled && onNavigate) {
      onNavigate(item.id);
    }
  };

  return (
    <>
      <Flex direction="column" h="100vh">
        {/* Header */}
        <Flex 
          as="nav" 
          alignItems="center" 
          justifyContent="space-between" 
          h='16' 
          py='2.5' 
          px='4'
          bg={color.grey}
          color={color.lightWhite}
        >
          <HStack spacing={2}>
            <IconButton 
              {...buttonProps} 
              _active='none' 
              _focus='none' 
              _hover='none' 
              fontSize="18px" 
              colorScheme='ghost' 
              icon={<HamburgerIcon />} 
              aria-label='open menu'
              color={color.lightWhite}
            />
            <img src={calibriteLogo} alt="Calibrite Logo" style={{ width: '40px', height: '40px' }} />
          </HStack>
          <HStack spacing={4}>
            <LanguageSelector languages={softwareLanguages} />
            {profileMenu}
          </HStack>
        </Flex>

        {/* Color Bar */}
        <BarStrip />

        {/* Main Content */}
        <HStack align="start" spacing={0} flex={1}>
          {/* Sidebar */}
          <Box 
            as="aside" 
            minH="100%" 
            w={isOpen ? null : 12} 
            bg={color.grey}
            color={color.lightWhite}
            borderRight="2px" 
            borderColor={useColorModeValue('gray.200', 'gray.900')} 
            transition="width 0.25s ease"
            pr={isOpen ? 2 : 1}
          > 
            <List spacing={0}>
              {listItems.map(item => (
                <ListElement 
                  key={item.text} 
                  Icon={item.icon} 
                  disabled={item.disabled} 
                  text={isOpen ? item.text : ''} 
                  onClick={() => handleItemClick(item)}
                  isActive={activeItem === item.id}
                />
              ))}
            </List>
          </Box>

          {/* Main Content Area */}
          <Box 
            as="main" 
            w='full' 
            minH="100%" 
            maxH="calc(100vh - 5.5rem)"
            overflowY="auto"
            bg={useColorModeValue('gray.50', 'gray.900')} 
            p={4}
          >
            {children}
          </Box>
        </HStack>
      </Flex>
    </>
  )
}

const ListElement = ({ Icon, text, disabled, onClick, isActive }) => {
  return (
    <ListItem 
      as={HStack} 
      spacing={0} 
      h="10" 
      pl="2.5" 
      cursor={disabled ? 'default' : 'pointer'} 
      bg={isActive ? color.lightGrey : 'transparent'}
      _hover={{ bg: disabled ? 'none' : color.lightGrey }} 
      rounded="md"
      onClick={!disabled ? onClick : undefined}
    >
      {Icon && <Box as={Icon} boxSize={5} marginRight={2} color={color.lightWhite} />}
      {text && <Text>{text}</Text>}
    </ListItem>
  )
} 